/** @file shortestYawDelta: the signed shortest turn between two angles, in (-180, 180] degrees. */

/** `to - from` wrapped into (-180, 180]; `shortestYawDelta(0, a)` wraps `a` itself. Never returns -0. */
export function shortestYawDelta(fromDeg: number, toDeg: number): number {
  const d = ((((toDeg - fromDeg) % 360) + 540) % 360) - 180;
  return d === -180 ? 180 : d + 0;
}
